/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Action_ApproveInputs */

const vi_stocktake_action_approve = /** @type {(inputs: Stocktake_Action_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duyệt`)
};

/**

* @param {Stocktake_Action_ApproveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_action_approve = /** @type {((inputs?: Stocktake_Action_ApproveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Action_ApproveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_action_approve(inputs)
});